import React, { useEffect, useContext, useState } from 'react';
import { IServiceSpec } from 'data/service-spec';
import { useToggle, useComplexState, slashTrim, camelToTitle, setStateByPath, StateTreeSetter } from 'utility';
import _ from 'lodash';
import { DirectoryBlock } from './directory-block';
import { useHistory } from 'react-router-dom';
import { DisplayContext } from './editor-page';
import { config } from 'config';

export type SelectionSetter = (setter: (selections: object) => object, path: string, invalidator?: () => void) => void;

interface IServiceBlockProps {
    service: IServiceSpec;
    selections: object;
    setSelection: StateTreeSetter<object>;
}

const selectedClass = (name: string, selections: any) => (selections && selections[name] ? "jd-selected" : "");
const selectedRequiresOpen = (selections: object) => (Object.keys(selections || {}).filter(key => key !== '_directory').length > 0);

const ServiceBlockInner = ({ service, selections, setSelection }: IServiceBlockProps) => {
    const [ isOpen, toggleOpen ] = useToggle(selections && !_.isEmpty(selections));
    const history = useHistory();

    const path = slashTrim(service.basePath);
    const dirPath = path.split('/');
    const onSelectDirectory = () => {
        //setSelection(ensureSingleSelection(dirPath));
        history.push('/' + path + '/');
    };
    return (
        <div className="content-type">
            <h2>
                <span className={isOpen ? "jd-toggle is-open" : "jd-toggle is-closed"} onClick={toggleOpen}></span>
                <span className={'jd-service ' + selectedClass('_directory', selections)} onClick={onSelectDirectory}>
                    {camelToTitle(service.name)}
                </span>
            </h2>
            {isOpen && <DirectoryBlock {...{ selections, setSelection, path, service }} />}
        </div>
        );
}

const ServiceBlock = React.memo(ServiceBlockInner);

interface IServiceIndexProps {
    services: IServiceSpec[],
    path: string;
}

export const ServiceIndex = ({
    services,
    path
}: IServiceIndexProps) => {
    const [ selections, setSelection ] = useComplexState<object>({});
    const history = useHistory();
    const [ , setDisplay ] = useContext(DisplayContext);
    const [ actionsOpen, setActionsOpen ] = useState(false);

    useEffect(() => {
        if (path) {
            setSelection(() => setStateByPath({}, path.split('/'), true));
        }
    }, [ path ]);

    const onServices = () => {
        history.push('/services.json');
        setDisplay({ showPane: true });
    }

    const toggleActions = () => {
        setActionsOpen(open => !open);
    }

    const onLogout = async () => {
        if (await config.api.logout()) {
            document.location.reload();
        }
    }

    const servicesService = services.find(s => s.name === 'services');

    return (
        <>
            <div className="rs-site" onClick={onServices}>
                <span className='spacer'></span>
                {servicesService && <h2 className="tenant">{servicesService.tenant}</h2>}
                <span className={actionsOpen ? "jd-toggle is-open" : "jd-toggle is-closed"} onClick={toggleActions}></span>
            </div>
            {actionsOpen && <div className='drop-panel'>
                <a onClick={onLogout}>Logout</a>
            </div>}
            <div className="content-types">
                {services.filter(s => s.name !== 'services').map((service) => {
                    const serviceSelections = selections && _.get(selections, slashTrim(service.basePath).split('/'));
                    return (
                        <ServiceBlock
                            service={service}
                            key={service.name}
                            selections={serviceSelections}
                            setSelection={setSelection}/>
                    );
                })}
            </div>
        </>
    );
}